// Function to parse and format a phone number, returning a PhoneNumber object
// The function expects the phone number to be in the E.164 format, which typically starts
// with a plus sign (+) followed by the country code and the phone number.

import parsePhoneNumberFromString, { PhoneNumber } from 'libphonenumber-js';

import { COUNTRY } from 'types/common';

function getPhoneNumberObject(phoneNumber: string): PhoneNumber | null {
  // Ensure the phone number starts with a plus sign
  if (!phoneNumber.startsWith('+')) {
    phoneNumber = '+' + phoneNumber;
  }

  const phoneNumberObject = parsePhoneNumberFromString(phoneNumber, COUNTRY.NORWAY);
  return phoneNumberObject ? phoneNumberObject : null;
}

export default getPhoneNumberObject;
